export default __webpack_public_path__ + "static/media/discover.835cf9f6.svg";